import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CardWidgetNewPasswordInput from '../CardWidgetNewPasswordInput';
import CardWidgetInputErrorHOC from "./CardWidgetInputErrorHOC";

class CardWidgetNewPasswordInputWithErrors extends Component {
  render() {
    return (
        <CardWidgetNewPasswordInput fieldLabel={this.props.fieldLabel} onChange={this.props.onChange} onBlur={this.props.onBlur}/>
    )
  }
}

CardWidgetNewPasswordInputWithErrors.propTypes = {
  onChange: PropTypes.func,
  fieldLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  onBlur: PropTypes.func
};

export default CardWidgetInputErrorHOC(CardWidgetNewPasswordInput);